import { Slot } from "expo-router";

const Layout: React.FC = () => <Slot />;

export default Layout;
